import './risultato-ricerca.scss';

/**
 * version    1.0
 * class      <type> (RisultatoRicerca)
 * classdesc
 */
export class RisultatoRicerca {}
